import { useState } from 'react';

const ShareQuizModal = ({ isOpen, onClose, quizId }) => {
  const [copied, setCopied] = useState(false);
  const quizUrl = `${window.location.origin}/quizzes/${quizId}/view`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(quizUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy link:", err);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-lg font-semibold mb-2">Share Quiz Link</h2>
        <div className="mb-4">
          <input type="text" value={quizUrl} readOnly className="input input-bordered w-full" />
        </div>
        <div className="flex justify-end gap-2">
          <button className="btn btn-outline" onClick={onClose} type="button">
            Close
          </button>
          <button className="btn btn-primary" onClick={handleCopyLink} type="button">
            {copied ? "Copied!" : "Copy Link"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareQuizModal;
